<template>
  <div class="wrap">
    <div class="col border-bottom">
      <input type="number" placeholder="请输入手机号码" v-model="phone">
    </div>
    <div class="col border-bottom">
      <input type="number" placeholder="请输入验证码" v-model="code">
      <div class="get-code" :class="{disable: !phoneRrigh}" @click="getcode">{{sended?sec+'s':'获取验证码'}}</div>
    </div>
    <div class="btn" @click="submit">完成验证</div>
    <loading v-if="submiting"></loading>
  </div>
</template>

<script>
import {RES_OK} from '@/api/config'
import {sendCode, bindPhone} from '@/api/user-center'
import Loading from 'components/base/loading/loading.vue'
export default {
  components: {
    Loading
  },
  data() {
    return {
      phone: '',
      code: '',
      sended: false,
      sec: 0,
      submiting: false
    }
  },
  computed: {
    phoneRrigh() {
      return /^1[\d]{10}$/.test(this.phone)
    }
  },
  methods: {
    getcode() {
      if (!this.phoneRrigh || this.sended) return
      // console.log(this.phone)
      this.countdown(60)
      sendCode(this.phone).then(({data}) => {
        if (data.code === RES_OK) {
          this.$toast('发送成功')
        } else {
          this.$toast('发送失败')
        }
      })
    },
    submit() {
      if (this.submiting) return
      if (!this.phoneRrigh) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!/^[\d]{4}$/.test(this.code)) {
        this.$toast('验证码错误')
        return
      }
      this.submiting = true
      bindPhone(this.phone, this.code).then(({data}) => {
        if (data.code === RES_OK) {
          this.submiting = false
          this.$router.replace({
            path: '/personal/bindsuccess'
          })
        }
      })
    },
    countdown(all) {
      this.sended = true
      this.sec = all
      const timer = setInterval(() => {
        if (--this.sec <= 0) {
          clearInterval(timer)
          this.sended = false
        }
      }, 1000)
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    padding size(20) size(48) 0
  .col
    display flex
    align-items center
    min-height size(90)
    &:before
      background #afafaf
    input
      font-size size(32)
      color #7c7979
      flex 1
      outline none
      padding 0 size(6)
      &::-webkit-input-placeholder
        color #d8d8d8
    .get-code
      color $color-theme
      line-height size(58)
      border-radius size(29)
      background #f4f4f4
      font-size size(28)
      padding 0 size(24)
      min-width size(194)
      margin-left 20px
      text-align center
      &.disable
        opacity .65
  .btn
    line-height size(88)
    border-radius size(44)
    background $color-theme
    color #fff
    text-align center
    font-size size(32)
    margin-top size(50)
</style>


// WEBPACK FOOTER //
// src/components/personal/bindphone/index.vue